import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray, uniqueId } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';

import Buffering from "../components/Buffering"; 
import ShowError from "../components/ShowError";


import dsd from "../classes/clsDSD";

import { getLogicalModel, getEntity, addEntity, editEntity } from "../utils/utilsLogicalModel";

import D3Graphviz from "../components/D3Graphviz";
import ViewEntity from "../components/ViewEntity";
import ViewLogicalModel from "../components/ViewLogicalModel";
import ViewMetadata from "../components/ViewMetadata";

import FormAttribute from "../components/FormAttribute";
import FormConcept from "../components/FormConcept";


import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";

import Rendition from '../components/Rendition';


import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Entity extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.addAttribute = this.addAttribute.bind(this);
        this.removeAttribute = this.removeAttribute.bind(this);
        this.updateAttribute = this.updateAttribute.bind(this);
        this.moveAttributeUp = this.moveAttributeUp.bind(this);
        this.moveAttributeDown = this.moveAttributeDown.bind(this);

        this.addConcept = this.addConcept.bind(this);
        this.removeConcept = this.removeConcept.bind(this);
        this.updateConcept = this.updateConcept.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadLogicalModel(id){

        this.setState({
            renderState: "loading"
        });

        const onLoad = (LogicalModel) => {
            let StateChange = {
                renderState: "loaded",
                LogicalModel: LogicalModel,
            };

            // Only set default FormData for 'new' mode
            if (this.state.mode === 'new'){
                StateChange.FormData = {status: 'in use'};
            }

            // Check permission for edit
            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id == LogicalModel.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            // Check if editing is allowed for this mode
            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Entities to this Logical Model";
                        break;
                }
            }

            this.setState(StateChange);
        };

        const onFail = (error) => {
            this.setState({
                renderState: error.status || "failed",
                errorMessage: error.errorMessage
            });
        };

        getLogicalModel(this.dsd, id, onLoad, onFail);
        
    };

    loadEntity(id){

        this.setState({
            renderState: "loading"
        });

        const onLoad = (Entity) => {
            let StateChange = {
                renderState: "loaded",
                Entity: Entity,
                LogicalModel: Entity.LogicalModel,
                FormData: Entity
            };

            if (Entity.LogicalModel){
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsLogicalModel(Entity.LogicalModel._id);
                }
            }


            // Check permission for edit
            StateChange.OfferEdit = false;
            if (Entity.LogicalModel){
                if (this.dsd.loggedon){
                    if (this.dsd.user.id == Entity.LogicalModel.idUser){
                        StateChange.OfferEdit = true;
                    }
                }
            }

            // Check if editing is allowed for this mode
            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Entities to this Logical Model";
                        break;
                }
            }

            this.setState(StateChange);

            // Fetch DOT from server
            this.fetchViz(id);

        };

        const onFail = (error) => {
            this.setState({
                renderState: error.status || "failed",
                errorMessage: error.errorMessage
            });
        };

        getEntity(this.dsd, id, onLoad, onFail);
        
    };

    fetchViz(id) {

        const onDoneDot = function(dot) {
            this.setState({ dot: dot });
        }.bind(this);

        const onFailDot = function(error) {
            console.error('Failed to fetch DOT:', error);
        }.bind(this);

        getEntity(this.dsd, id, onDoneDot, onFailDot, 'dot', null, this.state.Controls);

    };


    setup(){

        let StateChange = {

            mode: "view",

            idEntity: null,
            idLogicalModel: null,

            LogicalModel: null,
            Entity: null,

            isUpdated: false,
            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {
                status:'in use'
            },

            OfferEdit:false,

            Controls: {
            },

            dot: null,

            countRevisions: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idEntity = getParam('id', this.props);
        StateChange.idLogicalModel = getParam('idLogicalModel', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idLogicalModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Logical Model not specified when adding a Entity"
                }
                break;
            default:
                if (StateChange.idLogicalModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Logical Model should not be specified for an existing Entity"
                }
                if (!StateChange.idEntity){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Entity not be specified for an existing Entity"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idLogicalModel){
                this.FallBackNavigation = `/logicalmodel/${StateChange.idLogicalModel}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Load data based on mode
        if (StateChange.idLogicalModel && StateChange.mode === 'new'){
            this.loadLogicalModel(StateChange.idLogicalModel);
        }

        if (StateChange.idEntity){
            this.loadEntity(StateChange.idEntity);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;        
                this.setState({"FormData": FormData});
                break;                
        }
        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);
        switch (event.target.name){
            
            case 'btnCancel':

                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/entity/${this.state.idEntity}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })

                const onAdd = (idEntity) => {
                    this.props.navigation(`/entity/${idEntity}`);
                };

                const onUpdate = (Entity) => {

                    // Update revision history
                    this.refRevision.current.update();
                    this.props.navigation(`/entity/${this.state.idEntity}`);

                };

                const onError = (error) => {
                    this.setState({
                        renderState: "error",
                        errorMessage: error.message,
                        isError: true,
                        error: error
                    });
                };
        
                switch (this.state.mode){
                    case 'new':
                        addEntity(this.dsd, this.state.idLogicalModel, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editEntity(this.dsd, this.state.idEntity, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };


    addConcept(){
        let FormData = {...this.state.FormData};
        FormData.Concepts = [...(FormData.Concepts || []), {}];
  
        this.setState({"FormData": FormData});
    }

    removeConcept(seq){

       let FormData = {...this.state.FormData};
       FormData.Concepts = [...(FormData.Concepts || [])];
       FormData.Concepts.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }


    updateConcept(seq, Concept){

       let FormData = {...this.state.FormData};
       FormData.Concepts = [...(FormData.Concepts || [])];
       FormData.Concepts[seq-1] = Concept;

       this.setState({"FormData": FormData});

    }

    addAttribute(){
        let FormData = {...this.state.FormData};
        FormData.Attributes = [...(FormData.Attributes || []), {}];
  
        this.setState({"FormData": FormData});

    }

    removeAttribute(seq){

       let FormData = {...this.state.FormData};
       FormData.Attributes = [...(FormData.Attributes || [])];
       FormData.Attributes.splice(seq-1, 1);
      
       this.setState({"FormData": FormData});

    }

    moveAttributeUp(seq){

        let FormData = {...this.state.FormData};
        FormData.Attributes = [...(FormData.Attributes || [])];
        
        // Swap with previous item
        [FormData.Attributes[seq-2], FormData.Attributes[seq-1]] =
        [FormData.Attributes[seq-1], FormData.Attributes[seq-2]];
        
        this.setState({"FormData": FormData});

    }

    moveAttributeDown(seq){

       let FormData = {...this.state.FormData};
       FormData.Attributes = [...(FormData.Attributes || [])];
      
       // Swap with next item
       [FormData.Attributes[seq-1], FormData.Attributes[seq]] =
       [FormData.Attributes[seq], FormData.Attributes[seq-1]];
      
       this.setState({"FormData": FormData});


    }


    updateAttribute(seq, Attribute){

       let FormData = {...this.state.FormData};
       FormData.Attributes = [...(FormData.Attributes || [])];
       FormData.Attributes[seq-1] = Attribute;

       this.setState({"FormData": FormData});

    }


    handleVizClick(event) {

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        
        if (idNode){
            let partsVizNodeId = idNode.split('_');
            switch(partsVizNodeId[0]){
                case 'concept':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/concept/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'entity':
                    if (partsVizNodeId.length > 3){
                        switch(partsVizNodeId[2]){
                            case 'structure':
                                this.props.navigation(`/structure/${partsVizNodeId[3]}`);
                                break;
                            case 'enumeration':
                                this.props.navigation(`/enumeration/${partsVizNodeId[3]}`);
                                break;
                        }
                    }else{
                        if (partsVizNodeId.length > 1){
                            this.props.navigation(`/entity/${partsVizNodeId[1]}`);
                        }
                    }
                    break;
                case 'structure':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/structure/${partsVizNodeId[1]}`);
                    }
                    break;
                case 'enumeration':
                    if (partsVizNodeId.length > 1){
                        this.props.navigation(`/enumeration/${partsVizNodeId[1]}`);
                    }   
                    break;
            }
        }

        event.preventDefault();

    };


    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Entity){
            return null;
        }

        try {

            return(
                <D3Graphviz dot={this.state.dot} onClick={this.handleVizClick}/>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }


        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Entity</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox><ShowError error={this.state.error}/></PD.ErrorBox>
                                }

                                <form> 
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.EntityStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {this.FormConcepts()}
                                    {this.FormAttributes()}

                                    <Revision ref={this.refRevision}  idAbout={this.state.idEntity}/>

                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Entity</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewEntity Entity={this.state.Entity}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":

                        let countConcepts = 0;
                        if (this.state.Entity.Concepts){
                            countConcepts = this.state.Entity.Concepts.length;
                        }

                        let countAttributes = 0;
                        if (this.state.Entity.Attributes){
                            countAttributes = this.state.Entity.Attributes.length;
                        }


                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Entity:{this.state.Entity.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewEntity Entity={this.state.Entity}/>

                                <br/>

                                <PD.Tabs>

                                <div label='Visualise'>
                                    {this.visualise()}
                                </div>


                                <div label={`Concepts(${countConcepts})`}>

                                    {isArray(this.state.Entity.Concepts) &&
                                        <PD.Table className="list">
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Name</PD.Th>
                                                    <PD.Th>Concept Model</PD.Th>
                                                    <PD.Th>Description</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>

                                            <PD.Tbody>
                                                {
                                                    this.state.Entity.Concepts.map(
                                                        (EntityConcept, pos) => 
                                                        {

                                                            if (EntityConcept.Concept){
                                                                return (
                                                                    <PD.Tr key={pos}>
                                                                        <PD.Td>
                                                                            <PD.PdNavLink to={"/concept/" + EntityConcept.Concept._id} > {EntityConcept.Concept.name}</PD.PdNavLink>
                                                                        </PD.Td>

                                                                        <PD.Td>
                                                                            {(() => {
                                                                                if (EntityConcept.Concept.ConceptModel){
                                                                                    return EntityConcept.Concept.ConceptModel.name;
                                                                                }
                                                                                return null;
                                                                            })()}
                                                                    </PD.Td>
                                                                        
                                                                        <PD.Td>
                                                                            {formatText(truncate(EntityConcept.Concept.description, 1000))}
                                                                        </PD.Td>

                                                                    </PD.Tr>

                                                                )
                                                            }else{
                                                                return(
                                                                    <PD.Tr key={pos}>
                                                                        <PD.Td>not permitted</PD.Td>
                                                                    </PD.Tr>
                                                                )
                                                            }
                                                        }
                                                    )
                                                }
                                            </PD.Tbody>
                                        </PD.Table>
                                    }

                                </div>


                                <div label={`Attributes(${countAttributes})`}>

                                    {isArray(this.state.Entity.Attributes) &&
                                        <PD.Table className="list">
                                            <PD.Thead>
                                                <PD.Tr>
                                                    <PD.Th>Name</PD.Th>
                                                    <PD.Th>Description</PD.Th>
                                                    <PD.Th>Data Type</PD.Th>
                                                    <PD.Th>Structure / Enumeration</PD.Th>
                                                    <PD.Th>Occurs</PD.Th>
                                                    <PD.Th>Required</PD.Th>
                                                </PD.Tr>
                                            </PD.Thead>

                                            <PD.Tbody>
                                                {
                                                    this.state.Entity.Attributes.map(
                                                        (Attribute, pos) => 
                                                        {
                                                            return (
                                                                <PD.Tr key={pos}>
                                                                    <PD.Td>
                                                                        {Attribute.name}
                                                                    </PD.Td>
                                                                   
                                                                    <PD.Td>
                                                                        {formatText(truncate(Attribute.description, 4000))}
                                                                    </PD.Td>


                                                                    {(() => {
                                                                        switch (Attribute.type) {
                                                                            case "structure":
                                                                                if (Attribute.Structure){
                                                                                    return (
                                                                                        <>
                                                                                            <PD.Td/>
                                                                                            <PD.Td>
                                                                                                <PD.PdNavLink to={"/structure/" + Attribute.Structure._id} > {Attribute.Structure.name}</PD.PdNavLink>
                                                                                            </PD.Td>
                                                                                        </>
                                                                                    );
                                                                                }                                                                                
                                                                                return (
                                                                                    <>
                                                                                        <PD.Td/>
                                                                                        <PD.Td/>
                                                                                    </>    
                                                                                )
                                                                                break;
                                                                            default:
                                                                                return(
                                                                                    <>
                                                                                        <PD.Td>
                                                                                            {Attribute.dataType}
                                                                                        </PD.Td>
                                                                                        <PD.Td>
                                                                                            {Attribute.Enumeration &&
                                                                                                <PD.PdNavLink to={"/enumeration/" + Attribute.Enumeration._id} > {Attribute.Enumeration.name}</PD.PdNavLink>
                                                                                            }
                                                                                        </PD.Td>
                                                                                    </>
                                                                                )
                                                                        }
                                                                    })()}


                                                                    <PD.Td>
                                                                        {Attribute.occurs}
                                                                    </PD.Td>

                                                                    <PD.Td>
                                                                        {Attribute.required}
                                                                    </PD.Td>


                                                                </PD.Tr>

                                                            )
                                                        }
                                                    )
                                                }
                                            </PD.Tbody>
                                        </PD.Table>
                                    }

                                </div>

                                    <div label='Logical Model'>
                                        <ViewLogicalModel LogicalModel={this.state.LogicalModel} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Entity} />
                                    </div>

                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idEntity}} onLoad={this.loadedRevisions}/>
                                    </div>


                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/entities"
                                            id={this.state.idEntity}
                                        />
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };


    FormConcepts(){

        let seqNext = 1;
        if (this.state.FormData.Concepts){
            seqNext = this.state.FormData.Concepts.length + 1;
        }
        return (
            <fieldset>
                <legend>Concepts</legend>
                {this.state.FormData.Concepts &&
                    this.state.FormData.Concepts.map(
                        (Concept, posConcept) => 
                        {
                            let seq = posConcept+1;
                            return(
                                this.FormConcept('edit', seq, Concept)
                            )
                        }
                    )
                }
                {this.FormConcept('new', seqNext)}
            </fieldset>
        );

    }

    FormConcept(mode, seq, Concept = {}){
        return(
            <div>
                <FormConcept 
                    key={seq.toString()} 
                    mode={mode}
                    onAdd={this.addConcept}
                    onRemove={this.removeConcept}
                    onUpdate={this.updateConcept}
                    Concept={Concept} 
                    seq={seq}
                />
            </div>

        )
    }

    FormAttributes(){

        let seqNext = 1;
        if (this.state.FormData.Attributes){
            seqNext = this.state.FormData.Attributes.length + 1;
        }
        return (
            <fieldset>
                <legend>Attributes</legend>
                {this.state.FormData.Attributes &&
                    this.state.FormData.Attributes.map(
                        (Attribute, posAttribute) => 
                        {
                            let seq = posAttribute+1;
                            return(
                                this.FormAttribute('edit', seq, Attribute)
                            )
                        }
                    )
                }
                {this.FormAttribute('new', seqNext)}
            </fieldset>
        );

    }

    FormAttribute(mode, seq, Attribute = {}){

        let onMoveUp = null;
        if (seq>1) {
            onMoveUp = this.moveAttributeUp;
        }

        let onMoveDown = null;
        if (this.state.FormData.Attributes){
            if (seq<this.state.FormData.Attributes.length) {
                onMoveDown = this.moveAttributeDown;
            }
        }


        let key=null;
        if (Attribute._id){
            key = Attribute._id;
        }
        else if(Attribute._tempId){
            key = Attribute._tempId;
        }
        else{
            Attribute._tempId = `temp_${Date.now()}`;
            key = Attribute._tempId;
        }

        return(
            <div>
                <FormAttribute 
                    key={key}
                    mode={mode}
                    onAdd={this.addAttribute}
                    onRemove={this.removeAttribute}
                    onUpdate={this.updateAttribute}
                    {...(onMoveUp && { onMoveUp:onMoveUp})}
                    {...(onMoveDown && { onMoveDown:onMoveDown})}
                    Attribute={Attribute} 
                    seq={seq}
                />
            </div>
        )
    }


};

// Wrap and export
export default function Entity_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Entity {...props} navigation={navigation} location={location} params={params} />;
  }
